module.exports = __webpack_public_path__ + "static/img/qqEmoji.6f577b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qqEmoji.png
// module id = 0MaN
// module chunks = 1